const GroupNote = {
  id: 0,
  title: "",
  content: "",
};

export default GroupNote;
